<template>
  <BaseShareSentiment
    :title="title"
    :item-id="itemId"
    :operation="operation"
    :field="field"
    :group="group"
    :label="label"
    :polarity="polarity"
    :hide-null="hideNull"
    :filter-name="filterName"
    :stack-labels="stackLabels"
    v-bind="$attrs"
  />
</template>

<script>
import BaseShareSentiment from '@/components/cards/BaseShareSentiment';
import { OPERATION } from '@/services/charts-service';
import proprietaryModel from '@/mixins/proprietary-model';

export default {
  name: 'PropBaseShareSentiment',
  components: {
    BaseShareSentiment,
  },
  mixins: [
    proprietaryModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    operation: {
      type: String,
      default: OPERATION.COUNT,
    },
    field: {
      type: String,
      default: null,
    },
    group: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
    polarity: {
      type: Boolean,
      default: true,
    },
    hideNull: {
      type: Boolean,
      default: false,
    },
    stackLabels: {
      type: [Boolean, String],
      default: true,
    },
    filterName: {
      type: String,
      default: null,
    },
  },
};
</script>
